import type { AnamnesisTemplate } from './templates';

const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

/**
 * Renders a template into the HTML seeded into the editor: one heading per section
 * followed by an empty paragraph. Fully editable afterwards. Patient data is not
 * injected here — it is shown read-only in the rail (see patient-info.ts).
 */
export function buildTemplateHtml(template: AnamnesisTemplate): string {
    return template.sections
        .map((section) => `<h2>${escapeHtml(section.title)}</h2><p></p>`)
        .join('');
}
